import { render, staticRenderFns } from "./ComunicacionBajaEmision.vue?vue&type=template&id=978250ea&scoped=true&"
import script from "./ComunicacionBajaEmision.vue?vue&type=script&lang=js&"
export * from "./ComunicacionBajaEmision.vue?vue&type=script&lang=js&"
import style0 from "./ComunicacionBajaEmision.vue?vue&type=style&index=0&id=978250ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978250ea",
  null
  
)

export default component.exports